import { render, staticRenderFns } from "./Remove.vue?vue&type=template&id=e3f55178&scoped=true&"
import script from "./Remove.vue?vue&type=script&lang=js&"
export * from "./Remove.vue?vue&type=script&lang=js&"
import style0 from "./Remove.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Remove.vue?vue&type=style&index=1&id=e3f55178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f55178",
  null
  
)

export default component.exports